// @ts-nocheck
import { css } from 'styled-components';
import { pxToRem, breakpoint } from '@fil-react-mixins/styled';
const defaultSpacing = 1;
const attrsMap = {
    p: ['padding'],
    px: ['padding-left', 'padding-right'],
    py: ['padding-top', 'padding-bottom'],
    pl: ['padding-left'],
    pr: ['padding-right'],
    pt: ['padding-top'],
    pb: ['padding-bottom'],
    m: ['margin'],
    mx: ['margin-left', 'margin-right'],
    my: ['margin-top', 'margin-bottom'],
    ml: ['margin-left'],
    mr: ['margin-right'],
    mt: ['margin-top'],
    mb: ['margin-bottom'],
};
const attrs = Object.keys(attrsMap);
const transformValue = (value, 
/* istanbul ignore next */
{ size: { spacing = defaultSpacing } } = {}) => {
    if (typeof value === 'string') {
        return value;
    }
    if (typeof spacing === 'number') {
        return value * spacing;
    }
    if (typeof spacing === 'object') {
        if (value < 0) {
            return -parseInt(spacing[Math.abs(value)].value, 10);
        }
        return parseInt(spacing[value].value, 10);
    }
    if (typeof spacing === 'function') {
        return spacing(value);
    }
    return value;
};
export default css `
  ${(props) => {
    return attrs
        .map((attr) => {
        const value = props[attr];
        if (typeof value !== 'undefined') {
            if (typeof value === 'object') {
                return Object.keys(value)
                    .map((key) => {
                    const transformedValue = pxToRem(transformValue(value[key], props.theme));
                    return attrsMap[attr]
                        .map((attrName) => breakpoint(key, `${attrName}: ${transformedValue};`, {
                        breakpoints: props.theme.size.breakpoint,
                    }).join(''))
                        .join('');
                })
                    .join('');
            }
            const transformedValue = pxToRem(transformValue(value, props.theme));
            return attrsMap[attr]
                .map((attrName) => `${attrName}: ${transformedValue};`)
                .join('');
        }
        return '';
    })
        .join('');
}};
`;
